import { Component, HostBinding } from '@angular/core';
import { UserTranslationService } from '../../../services/user-translation/user-translation.service';

@Component({
  selector: 'app-register',
  templateUrl: 'register.component.html',
})
export class RegisterComponent {
  @HostBinding('class') cAppClass = 'c-app flex-row align-items-center';

  constructor(
    public userTranslationService: UserTranslationService,
  ) { }
}
